import {register} from '../modules/eventMap';

const selectCountry = (el) => {
    const selectedOption = el.options[el.selectedIndex];
    const {icon} = selectedOption.dataset;
    const target = document.querySelector(
        `[data-select-country-target="true"]`
    );
    target.textContent = icon;
};

const phoneNumber = () => {
    register('phoneNumber', {
        selectCountry
    });
};

export {phoneNumber};
